import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  LIST_CATEGORIA_INIT,
  CREATE_CATEGORIA_INIT,
  DELETE_CATEGORIA_INIT,
  UPDATE_CATEGORIA_INIT
} from '../actionTypes';
import { FarmaError } from 'src/integracoes/modelos/erros';
import { ICategoria } from 'src/integracoes/servicos/mongo-atlas/modelos/ICategoria';
import { categoriaErrorMsg, createCategoriaPainelSuccess, deleteCategoriaPainelSuccess, listCategoriaPainelSuccess, updateCategoriaPainelSuccess } from './actions';
import { atualizarCategoria, criarCategoria, deletarCategoria, listarCategorias } from 'src/integracoes/servicos/mongo-atlas/funcoes/categorias';

interface FetchListaCategoriasResult {
  isError: boolean;
  categorias: ICategoria[] | null;
  errorMessage: string | null;
}

/* ------------------Lista categorias---------------- */
export const fetchListarCategorias = async (): Promise<FetchListaCategoriasResult> => {
  try {
    const { status, dados, mensagem } = await listarCategorias();
    if (status && Array.isArray(dados)) {
      return {
        isError: false,
        categorias: dados,
        errorMessage: null,
      };
    }

    return {
      isError: true,
      categorias: [],
      errorMessage: mensagem,
    };
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseListarCategorias() {
  try {
    const result: FetchListaCategoriasResult = yield call(fetchListarCategorias);

    if (!result.isError) {
      yield put(listCategoriaPainelSuccess({ categorias: result.categorias }));
    } else {
      yield put(categoriaErrorMsg({ msg: result.errorMessage }));
    }
  } catch (error: any) {
    yield put(
      categoriaErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchListarCategorias() {
  yield takeEvery(LIST_CATEGORIA_INIT, parseListarCategorias);
}


/* ------------------Criar categoria ---------------- */
export const fetchCriarCategoria = async (categoria: any) => {
  try {
    const { status, dados, mensagem } = await criarCategoria(categoria);
    if (status) {
      return {
        isCreated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isCreated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseCriarCategoria({ payload }: { payload: any, type: any }) {
  const { categoria } = payload;

  try {
    const { isCreated, msg } = yield call(fetchCriarCategoria, categoria);
    if (isCreated) {
      yield put(createCategoriaPainelSuccess({ msg, isCreated }));
    } else {
      yield put(categoriaErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(
      categoriaErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchCriarCategoria() {
  yield takeEvery(CREATE_CATEGORIA_INIT, parseCriarCategoria);
}


/* ------------------Atualiza categoria ---------------- */
export const fetchAtualizarCategoria = async (id: string, categoria: any) => {
  try {
    const { status, dados, mensagem } = await atualizarCategoria(id, categoria);
    if (status) {
      return {
        isUpdated: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isUpdated: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseAtualizarCategoria({ payload }: { payload: any; type: any }) {
  const { id, categoria } = payload;
  try {
    const { isUpdated, msg } = yield call(fetchAtualizarCategoria, id, categoria);
    if (isUpdated) {
      yield put(updateCategoriaPainelSuccess({ msg, isUpdated }));
    } else {
      yield put(categoriaErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(
      categoriaErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchAtualizarCategoria() {
  yield takeEvery(UPDATE_CATEGORIA_INIT, parseAtualizarCategoria);
}

/* ------------------Deletar categoria ---------------- */
export const fetchDeletarCategoria = async (id: string) => {
  try {
    const { status, mensagem, dados } = await deletarCategoria(id);
    if (status) {
      return {
        isDeleted: true,
        msg: mensagem,
        data: dados
      };
    } else {
      return { isDeleted: false, msg: mensagem, data: null };
    }
  } catch (error: any) {
    throw new FarmaError(error);
  }
};

function* parseDeletarCategoria({ payload }: { payload: any; type: any }) {
  const { id } = payload;
  try {
    const { isDeleted, msg } = yield call(fetchDeletarCategoria, id);

    if (isDeleted) {
      yield put(deleteCategoriaPainelSuccess({ msg, isDeleted }));
    } else {
      yield put(categoriaErrorMsg({ msg }));
    }
  } catch (error: any) {
    yield put(
      categoriaErrorMsg({
        msg: error.mensagem ? `${error.mensagem}` : `${error.message}`,
      })
    );
  }
}

export function* watchDeletarCategoria() {
  yield takeEvery(DELETE_CATEGORIA_INIT, parseDeletarCategoria);
}

// WATCHS
export default function* rootSaga() {
  yield all([
    fork(watchListarCategorias),
    fork(watchCriarCategoria),
    fork(watchAtualizarCategoria),
    fork(watchDeletarCategoria)
  ]);
}
